/**
 * Represents the creation status of a future recurring [[MemberSubscription]].
 */
export var FutureRecurringMemberSubscriptionCreationStatus;
(function (FutureRecurringMemberSubscriptionCreationStatus) {
    /**
     * Subscription creation has been requested, but the process hasn't started.
     */
    FutureRecurringMemberSubscriptionCreationStatus["NotStarted"] = "NotStarted";
    /**
     * Subscription is in the process of being created.
     */
    FutureRecurringMemberSubscriptionCreationStatus["Pending"] = "Pending";
    /**
     * Subscription failed to be created for some unexpected reason.
     */
    FutureRecurringMemberSubscriptionCreationStatus["Failed"] = "Failed";
    /**
     * Subscription was created successfully.
     */
    FutureRecurringMemberSubscriptionCreationStatus["Completed"] = "Completed";
})(FutureRecurringMemberSubscriptionCreationStatus || (FutureRecurringMemberSubscriptionCreationStatus = {}));
//# sourceMappingURL=future-recurring-member-subscription-creation-status.js.map